/**
 * Источник звука ошибки на время одного экрана набора.
 *
 * Звуковое устройство держится, пока открыт экран, и освобождается при уходе
 * с него: удерживать его на экране результата незачем.
 *
 * Возвращается неизменная функция: она попадает в обработчик нажатия, и новая
 * ссылка на каждый рендер перевешивала бы слушатель клавиатуры после каждой
 * напечатанной буквы.
 */

import { useCallback, useEffect, useRef } from 'react';
import { createErrorSound, type ErrorSound } from '@type2x/adapter-web';

export function useErrorSound(enabled: boolean): () => void {
  const soundRef = useRef<ErrorSound | null>(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const sound = createErrorSound();
    soundRef.current = sound;

    return () => {
      soundRef.current = null;
      sound.close();
    };
  }, [enabled]);

  return useCallback(() => soundRef.current?.play(), []);
}
